var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemoveBig = function SvgRemoveBig(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09985 5.09092H11.8999L11.2748 14.1831C11.2334 14.7849 10.7302 15.2727 10.153 15.2727H3.84674C3.26856 15.2727 2.76656 14.7885 2.72494 14.1831L2.09985 5.09092Z",
    stroke: "#EA4335",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7499 8L8.3999 12.3636",
    stroke: "#EA4335",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8L5.6 12.3636",
    stroke: "#EA4335",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75255 2.18181C1.17089 2.18181 0.699951 2.67028 0.699951 3.27284V3.99988C0.699951 4.60049 1.17121 5.0909 1.75255 5.0909H12.2474C12.829 5.0909 13.3 4.60243 13.3 3.99988V3.27284C13.3 2.67223 12.8287 2.18181 12.2474 2.18181L9.44995 1.8183C9.44995 1.21768 8.97932 0.727268 8.39878 0.727268H5.60112C5.01978 0.727268 4.54995 1.21574 4.54995 1.8183L1.75255 2.18181Z",
    stroke: "#EA4335",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/removeBig.9c1f0425.svg";
export { ForwardRef as ReactComponent };